import { incrementMetric } from '../../Services/Datadog';

export const NO_SUBMISSION_ID_ERROR_NAME = 'noSubmissionIdError';
export const NO_SUBMISSION_ID_ERROR_MESSAGE =
  'Arrived at thank you page without a valid form id';

/**
 * @param {?string} content
 * @returns {boolean} - true if the content is not a dash. the dash is used in capture to indicate that the content should not be rendered
 */
export const shouldRenderContent = (content) => {
  return content !== '-';
};

/**
 * formatTime
 * @param {isoDateString} param0
 * @returns {string} - formatted time in 24-hour format i.e. 14:30 or 15:00
 */
export const formatAppointmentTime = ({ isoDateString, locale }) => {
  const date = new Date(isoDateString);
  const APPOINTMENT_DURATION_HOURS = 1; // there is an end date to some of the appointments, but not all and currently we should only be requesting appointments which are an hour

  // Options to display the time in 24-hour format with the provided locale
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false, // 24-hour format
  };

  // Get start time formatted based on the locale
  const from = date.toLocaleTimeString(locale, options);

  // Calculate the end time by adding 1 hour to the original date
  const endDate = new Date(date);
  endDate.setHours(date.getHours() + APPOINTMENT_DURATION_HOURS);
  const to = endDate.toLocaleTimeString(locale, options);

  return `${from} - ${to}`;
};

/**
 * formatDate
 * @param {isoDateString} param0
 * @param {countryAlpha2} param1 i.e. ES for Spain
 * @returns {string} - formatted date i.e. Monday 1st January 2022
 */
export const formatDate = ({ isoDateString, countryAlpha2 }) => {
  const date = new Date(isoDateString);

  // Use Intl.DateTimeFormat for Spanish formatting
  const dayOfWeek = new Intl.DateTimeFormat(countryAlpha2, {
    weekday: 'long',
  }).format(date);
  const day = date.getDate();
  const month = new Intl.DateTimeFormat(countryAlpha2, {
    month: 'long',
  }).format(date);
  const year = date.getFullYear();

  return `${dayOfWeek} ${day} ${month} ${year}`;
};

export const logNoSubmissionIdError = (formId) => {
  incrementMetric({
    name: NO_SUBMISSION_ID_ERROR_NAME,
    tags: {
      error_thrown: NO_SUBMISSION_ID_ERROR_MESSAGE,
      form_id: formId,
    },
  });
};
